import { render, staticRenderFns } from "./SongEditCommon.vue?vue&type=template&id=aaf6da1c&"
import script from "./SongEditCommon.vue?vue&type=script&lang=js&"
export * from "./SongEditCommon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports